import { ProcedureType, SampleType } from "@/services/backend/types";
import { useParams } from "react-router";
import ResultTable from "./_components/result-table";

export function ResultIndexRoute() {
  const { reportId } = useParams();

  return (
    <div className="flex flex-col space-y-4">
      <ResultTable
        reportId={reportId as string}
        label="1N-RLT"
        procedureType={ProcedureType.RLT1N}
        sampleType={SampleType.SurfaceMicrobial}
        visibilityState={{
          mouldResult: false,
          "corrected-measurement-1": false,
          "corrected-measurement-2": false,
        }}
      />

      <ResultTable
        reportId={reportId as string}
        label="1N-RLT"
        procedureType={ProcedureType.RLT1N}
        sampleType={SampleType.AirMicrobial}
        visibilityState={{
          mouldResult: false,
          "corrected-measurement-1": false,
          "corrected-measurement-2": false,
        }}
      />

      <ResultTable
        reportId={reportId as string}
        label="2N-RLT"
        procedureType={ProcedureType.RLT2N}
        sampleType={SampleType.SurfaceMicrobial}
        collapsible
        visibilityState={{
          mouldResult: false,
          "corrected-measurement-1": false,
          "corrected-measurement-2": false,
        }}
      />

      <ResultTable
        reportId={reportId as string}
        label="2N-RLT"
        procedureType={ProcedureType.RLT2N}
        sampleType={SampleType.AirMicrobial}
        collapsible
      />
    </div>
  );
}

export default ResultIndexRoute;
